<template>
  <div class="view-toggles">
    <button
      class="grid-toggle view-btn"
      :class="viewType === 'grid' ? 'active' : 'inactive'"
      @click="emitView('grid')"
    >
      <i
        class="icon-sm icon-reg icon-grid"
        aria-hidden="true"
      />
      <span class="text">Grid View</span>
    </button>
    <button
      class="list-toggle view-btn"
      :class="viewType === 'list' ? 'active' : 'inactive'"
      @click="emitView('list')"
    >
      <i
        class="icon-sm icon-reg icon-list"
        aria-hidden="true"
      />
      <span class="text">List View</span>
    </button>
  </div>
</template>

<script>
export default {
  emits: {
    'change-view': null,
  },
  data() {
    return {
      viewType: 'grid',
    };
  },
  methods: {
    emitView(type) {
      this.viewType = type;
      this.$emit('change-view', type);
    }
  }
};
</script>
